import React, { useEffect, useState } from "react";
import Navbar from "./component/Navbar";
import { translations, LanguageCode } from "./utils/translations";
import { Link } from "react-router-dom";
import { COLORS, navLinkStyle } from "./utils/constants";

import { useLocation } from "react-router-dom";
import { trackPageView } from "./utils/googleanalytics";
import ProfileCompletionBanner from "./component/ProfileCompletionBanner";
import { useAuth } from "./context/AuthContext";
import { usePoints } from "./context/PointsContext";
import { formatPoints } from "./utils/pointsFormatter";
import LoginPromptBanner from "./component/LoginPromptBanner";
import AuthModal from "./component/Auth/AuthModal";
import Footer from "./Footer";
const LayoutTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search + location.hash);
  }, [location]);

  return null;
};

//const brandPurple = "#714B67";
//const brandTeal = "#017E84";

interface LayoutProps {
  lang: LanguageCode;
  setLang: (l: LanguageCode) => void;
  children: React.ReactNode;
}

const MainLayout: React.FC<LayoutProps> = ({ lang, setLang, children }) => {
  const { user, isAuthModalOpen } = useAuth();
  const { points } = usePoints();

  const [showProfileBanner, setShowProfileBanner] = useState(false);
  const [showLoginBanner, setShowLoginBanner] = useState(false);
  const [loginBannerCount, setLoginBannerCount] = useState(0);

  useEffect(() => {
    if (user) {
      const alreadyShown = sessionStorage.getItem("profile_banner_shown");

      if (!alreadyShown && Math.random() > 0.5) {
        setShowProfileBanner(true);
        sessionStorage.setItem("profile_banner_shown", "true");

        const timer = setTimeout(() => {
          setShowProfileBanner(false);
        }, 300000);

        return () => clearTimeout(timer);
      }
    } else {
      let interval: NodeJS.Timeout;
      let hideTimer: NodeJS.Timeout;

      interval = setInterval(() => {
        setLoginBannerCount((prev) => {
          if (prev >= 3) {
            clearInterval(interval);
            return prev;
          }

          setShowLoginBanner(true);

          // Hide after 5 minutes
          hideTimer = setTimeout(() => {
            setShowLoginBanner(false);
          }, 300000);

          return prev + 1;
        });
      }, 600000); // Every 10 minutes

      return () => {
        clearInterval(interval);
        if (hideTimer) clearTimeout(hideTimer);
      };
    }
  }, [user]);

  const t = translations[lang];

  return (
    <div style={{ fontFamily: '"Inter", sans-serif', color: "#1A202C" }}>
      <LayoutTracker />
      <Navbar
        currentLang={lang}
        onLanguageChange={setLang}
        solutionsText={t.solutions}
        methodologyText={t.methodology}
        dashBoardText={t.mydashboard}
        points={user ? points : undefined}
        pointsLabel={t.points}
        aboutText={t.about}
        ctaText={t.cta}
        contactText={t.contact.sidebarTitle}
        socialMediaPerformanceText={t.socialMediaPerformance}
        automationNavText={t.automationNav}
        blogsText={t.blogs}
        productsText={t.products}
        fieldServicePlannerText={t.fieldServicePlanner}
        servicesText={t.servicesNav}
        seeAllServicesText={t.seeAllServices}
        searchPlaceholderText={t.searchPlaceholder}
      />
      {user && showProfileBanner && <ProfileCompletionBanner />}
      {!user && showLoginBanner && <LoginPromptBanner />}
      <main>{children}</main>
      {isAuthModalOpen && <AuthModal />}
      <Footer lang={lang} />
    </div>
  );
};

export default MainLayout;
